var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-refresh",
    transform: "translate(0 -0.083)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    className: "cls-1",
    width: 22,
    height: 22,
    transform: "translate(0 0.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    className: "cls-2",
    d: "M3.536,15.213a7.7,7.7,0,0,0,.722,4.265s1.028,2.128,1.028,2.128A.921.921,0,0,1,4.12,22.863L1.39,21.784A1.838,1.838,0,0,1,.356,19.4l2.241.886A9.6,9.6,0,0,1,1.708,15,9.472,9.472,0,0,1,7.23,7.492a9.477,9.477,0,0,1,9.3.666L15.509,9.688A7.651,7.651,0,0,0,8,9.163,7.644,7.644,0,0,0,3.536,15.213ZM22.064,12.82a1.838,1.838,0,0,0-1.035-2.387L18.3,9.354a.921.921,0,0,0-1.166,1.258l1.03,2.127A7.72,7.72,0,0,1,18.884,17a7.64,7.64,0,0,1-4.494,6.062,7.645,7.645,0,0,1-7.53-.572L5.826,24.017a9.343,9.343,0,0,0,5.265,1.619,9.771,9.771,0,0,0,4.064-.9,9.46,9.46,0,0,0,4.664-12.8C19.823,11.934,22.064,12.82,22.064,12.82Z",
    transform: "translate(-0.214 -5.496)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.c4564c26.svg";
export { ForwardRef as ReactComponent };